module.exports = __webpack_public_path__ + "static/media/wave.c2592067.jpeg";